import React from 'react';
import { IIconProps } from '../interfaces';
const CheckIcon = (props: IIconProps) => {

  return (
      <svg width={ props.width } height={ props.height } className={ props.classes || '' } viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.697 0a.944.944 0 0 0-.63.282L4.952 7.429 1.593 4.435a.95.95 0 0 0-1.347.02.883.883 0 0 0-.244.668.89.89 0 0 0 .333.631l4.027 3.593a.952.952 0 0 0 1.297-.038l7.744-7.783a.877.877 0 0 0 .183-.995.934.934 0 0 0-.89-.53z" fill={ props.color } fillRule="nonzero"/>
      </svg>
  )
};

export default CheckIcon;